import script from "./PatientFormula.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientFormula.vue?vue&type=script&setup=true&lang=js"

import "./PatientFormula.vue?vue&type=style&index=0&id=1e3c435a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e3c435a"]])

export default __exports__